import { render } from "./breadCrumbs.vue?vue&type=template&id=29a02f1c&scoped=true&ts=true"
import script from "./breadCrumbs.vue?vue&type=script&lang=ts"
export * from "./breadCrumbs.vue?vue&type=script&lang=ts"

import "./breadCrumbs.vue?vue&type=style&index=0&id=29a02f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a02f1c"]])

export default __exports__